import request from './fileRequest';
export function uploadImage(url,data) {
    return request({
        url: url,
        method: 'post',
        data: data
    });
}
